 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Vehicle Registration No.
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryVehRegFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryVehRegFilterForm"
                            v-model="filtersVehReg.vehRegNo"
                            :label="filtersVehRegLabel.vehRegNo"
                            :error-messages="errors.collect('vehRegNo')"
                            data-vv-name="vehRegNo"
                            :data-vv-as="filtersVehRegLabel.vehRegNo"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearVehRegFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doVehRegFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="vehRegHeaders"
          :items="vehRegItems"
          v-bind:options.sync="paginationVehReg"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsVehReg"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.vehRegNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignVehReg(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      filtersVehRegLabel: {
        vehRegNo: 'Vehicle Registration No.'
      },
      filtersVehReg: {
        vehRegNo: undefined
      },
      vehRegItems: [],
      totalItemsVehReg: 0,
      vehRegHeaders: [
        { text: 'Veh Reg No.', align: 'left', value: 'vehRegNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationVehReg: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearVehRegFilters()
  },
  methods: {
    closeDialog() {
      this.filtersVehReg.vehRegNo = ''
      this.$emit('close')
    },
    doClearVehRegFilters() {
      this.filtersVehReg.vehRegNo = ''
      this.filtersVehReg.multiFundSfxCurr = this.multiFundSfxCurr
      this.filtersVehReg.accountNo = this.accountNo
      this.filtersVehReg.fund = this.fund
      this.filtersVehReg.acctNoSfx = this.acctNoSfx
      this.filtersVehReg.curr = this.curr
      this.fetchVehRegData()
    },
    doVehRegFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryVehRegFilterForm').then((result) => {
        if (result) {
          this.paginationVehReg.page = 1
          this.filtersVehReg.multiFundSfxCurr = this.multiFundSfxCurr
          this.filtersVehReg.accountNo = this.accountNo
          this.filtersVehReg.fund = this.fund
          this.filtersVehReg.acctNoSfx = this.acctNoSfx
          this.filtersVehReg.curr = this.curr
          this.fetchVehRegData()
        }
      })
    },
    assignVehReg(data) {
      this.$emit('assign-veh-reg-info', data)
      this.$emit('close')
    }
  },
  watch: {
    'paginationVehReg': function (value) {
      this.fetchVehRegData()
    },
    boolRefresh: function (value) {
      if (value) {
        this.doClearVehRegFilters()
      }
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    callerPage: {
      type: String,
      default: ''
    },
    accountNo: {
      type: String,
      default: ''
    },
    multiFundSfxCurr: {
      type: Boolean,
      default: false
    },
    fund: {
      type: String,
      default: ''
    },
    acctNoSfx: {
      type: String,
      default: ''
    },
    curr: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
